import Base from '@/gikam/js/components/base';
import Gikam from '@/gikam/js/core/gikam-core';
import I18N from '@/gikam/js/components/I18N';
import Vue from 'vue';
import '../css/home.css';
import '@/gikam/js/core/gikam-global-event';
import homeVue from '../vue/home';
import homeDeptVue from '../vue/homeDept';
import homeDeptRoleVue from '../vue/homeDeptRole';
import arrowDown from '../../../gikam/js/components/template/img/arrowDown.vue';
import scroll from '../../../gikam/js/components/template/scroll/vue/scroll';

Gikam.ignoreErrorUrl = ['logins/action/check-account'];

Vue.component('arrowDown', arrowDown);
Vue.component('scroll', scroll);

Gikam.component.I18N = I18N;

const defaultOptions = {
    //配置的logo标志
    logo: void 0,
    //国际化文件
    I18NUrl: void 0,
    //皮肤主题，选择范围green/blue
    skin: 'blue',
    //是否选择部门和角色
    selectDeptAndRole: false,
    //配置系统小图标
    xIconUrl: void 0,
    //系统名称
    system: void 0,
    //是否记住登录用户名
    userRemember: false
};

export default class HomePage extends Base {

    constructor(props) {
        super();
        this.initialize(props, defaultOptions).init();
    }

    init() {
        new I18N({
            url: this.options.I18NUrl,
            language: this.options.language
        }).done(() => {
            this.model = this.createViewModel();
        });
        this.initSystemInfo();
    }

    initSystemInfo() {
        document.title = this.options.title;
        if (this.options.xIconUrl) {
            const linkDom = document.createElement('link');
            Gikam.setDomAttribute(linkDom, {
                rel: 'icon',
                href: this.options.xIconUrl
            });
            document.head.appendChild(linkDom);
        }
    }

    createViewModel() {
        const _this = this;
        new Vue({
            data() {
                return _this.options;
            },
            render() {
                const home = this.selectDept ? homeDeptVue : (this.selectDeptAndRole ? homeDeptRoleVue : homeVue);
                return <home
                    logo={this.logo}
                    skin={this.skin}
                    system={this.system}
                    userRemember={this.userRemember}
                    description={this.description}
                >
                </home>;
            }
        }).$mount(Gikam.createDom('div', document.body));
    }

    static setConfig(props) {
        Object.assign(defaultOptions, props);
    }
}